/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScannerScanEndpointRequest
 */
export interface ScannerScanEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof ScannerScanEndpointRequest
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScannerScanEndpointRequest
     */
    recursive?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ScannerScanEndpointRequest
     */
    notify?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ScannerScanEndpointRequest
     */
    forceRescan?: boolean | null;
}

export function ScannerScanEndpointRequestFromJSON(json: any): ScannerScanEndpointRequest {
    return ScannerScanEndpointRequestFromJSONTyped(json, false);
}

export function ScannerScanEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScannerScanEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'recursive': !exists(json, 'recursive') ? undefined : json['recursive'],
        'notify': !exists(json, 'notify') ? undefined : json['notify'],
        'forceRescan': !exists(json, 'force_rescan') ? undefined : json['force_rescan'],
    };
}

export function ScannerScanEndpointRequestToJSON(value?: ScannerScanEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'recursive': value.recursive,
        'notify': value.notify,
        'force_rescan': value.forceRescan,
    };
}


